var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spnod-admin__form--container container mx-0 w-100",
    class: _vm.isMobile ? 'px-0' : 'px-3'
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments)
      }
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2",
    attrs: {
      "name": "code",
      "state": _vm.validateState('code'),
      "type": "text",
      "placeholder": "Verification Code",
      "size": "sm"
    },
    model: {
      value: (_vm.$v.form.code.$model),
      callback: function($$v) {
        _vm.$set(_vm.$v.form.code, "$model", $$v)
      },
      expression: "$v.form.code.$model"
    }
  }), _vm._v(" "), _c('b-input-group', {
    staticClass: "mb-2"
  }, [_c('b-form-input', {
    staticClass: "mb-0",
    attrs: {
      "name": "password",
      "state": _vm.validateState('password'),
      "type": _vm.isPasswordDisplayed,
      "placeholder": "Password",
      "size": "sm"
    },
    model: {
      value: (_vm.$v.form.password.$model),
      callback: function($$v) {
        _vm.$set(_vm.$v.form.password, "$model", $$v)
      },
      expression: "$v.form.password.$model"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('span', {
    staticClass: "input-group-text small spnod-cursor",
    on: {
      "click": _vm.handlePassToggle
    }
  }, [(!_vm.showPassword) ? _c('i', {
    staticClass: "fa fa-eye fa-sm"
  }) : _c('i', {
    staticClass: "fa fa-eye-slash fa-sm"
  })])])], 1), _vm._v(" "), _c('ul', {
    staticClass: "spnod-admin__form--list mb-2"
  }, [_c('li', [_c('router-link', {
    staticClass: "spnod-admin__form--link",
    attrs: {
      "id": "resend",
      "to": "/resend-code"
    }
  }, [_vm._v("Resend Code")])], 1)]), _vm._v(" "), (_vm.form.error !== '') ? _c('div', [_vm._v(_vm._s(this.form.error))]) : _vm._e(), _vm._v(" "), _c('b-form-group', {
    staticClass: "d-flex justify-content-end"
  }, [_c('b-button', {
    staticClass: "spnod-admin__form--button",
    attrs: {
      "type": "submit",
      "size": "sm",
      "disabled": _vm.isDisabled
    }
  }, [(!_vm.isSending) ? _c('p', [_vm._v("Send")]) : _c('span', {
    staticClass: "spinner-border spinner-border-sm",
    attrs: {
      "role": "status",
      "aria-hidden": "true"
    }
  })])], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4932d469","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/Forms/VerifyForm.vue
// module id = w9tr
// module chunks = 2